import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import HtmlArtifactView from '../../artifactPage/HtmlArtifactView';
import useArtifactContent from '../hooks/useArtifactContent';
import SidePanel from './SidePanel';
import ArtifactSwitcher from './ArtifactSwitcher';
import ArtifactActions from './ArtifactActions';
import css from './ArtifactShelf.css';

const DEFAULT_PANEL_WIDTH_PERCENT = 65;
const COLLAPSE_BELOW_PERCENT = 8;
const STORAGE_KEY = 'artifactShelfWidth';

const ArtifactShelf = ({
    artifacts,
    openArtifactId,
    isMaximized = false,
    onShowArtifact,
    onToggleMaximized,
    onClose,
}) => {
    const open = useMemo(() => artifacts.find(artifact => artifact.id === openArtifactId), [artifacts, openArtifactId]);

    const { content, isLoading, error } = useArtifactContent(open?.contentUrl);

    return (
        <SidePanel
            className={css.shelf}
            storageKey={STORAGE_KEY}
            defaultPercent={DEFAULT_PANEL_WIDTH_PERCENT}
            collapseBelowPercent={COLLAPSE_BELOW_PERCENT}
            isExpanded={isMaximized}
            onClose={onClose}
        >
            <div className={css.header}>
                <span className={css.marker} />
                <ArtifactSwitcher artifacts={artifacts} openArtifactId={open?.id} onShowArtifact={onShowArtifact} />
                <ArtifactActions
                    artifact={open}
                    content={content}
                    isMaximized={isMaximized}
                    onToggleMaximized={onToggleMaximized}
                    onClose={onClose}
                />
            </div>
            <div className={css.body}>
                <HtmlArtifactView
                    content={content}
                    isLoading={isLoading}
                    error={error}
                    frameKey={open?.id}
                    showVisibility
                />
            </div>
        </SidePanel>
    );
};

const artifactShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    contentUrl: PropTypes.string.isRequired,
    time: PropTypes.string,
});

ArtifactShelf.propTypes = {
    artifacts: PropTypes.arrayOf(artifactShape).isRequired,
    openArtifactId: PropTypes.string,
    isMaximized: PropTypes.bool,
    onShowArtifact: PropTypes.func.isRequired,
    onToggleMaximized: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ArtifactShelf;
